import type { ZapiAction, ZapiParam } from '@weft/zapi-types';
import { PAGINATION_QUERY_PARAMETERS, SEARCH_QUERY_PARAMETER } from '../../../api-definition-params';
import { BillingCycleInvoiceTypeSchema } from './billing-cycle-invoice-type-query-parameter';
import { GET_BILLING_CYCLE_INVOICES_PATH } from './get-billing-cycle-invoices-path';
import { GetBillingCycleInvoicesResponseSchema } from './get-billing-cycle-invoices-response-schema';

const BILLING_CYCLE_INVOICE_TYPE_QUERY_PARAMETER = {
  name: 'billingCycleInvoiceType',
  location: 'query',
  schema: BillingCycleInvoiceTypeSchema.optional(),
} as const satisfies ZapiParam;

export const GET_BILLING_CYCLE_INVOICES_ACTION = {
  method: 'get',
  codeGenerationSettings: {
    actionText: 'get-billing-cycle-invoices',
  },
  queryParams: {
    ...PAGINATION_QUERY_PARAMETERS,
    [BILLING_CYCLE_INVOICE_TYPE_QUERY_PARAMETER.name]: BILLING_CYCLE_INVOICE_TYPE_QUERY_PARAMETER,
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER,
  },
  response: {
    name: 'GetBillingCycleInvoicesResponse',
    schema: GetBillingCycleInvoicesResponseSchema,
  },
  path: GET_BILLING_CYCLE_INVOICES_PATH,
} satisfies ZapiAction;

export type GetBillingCycleInvoicesAction = typeof GET_BILLING_CYCLE_INVOICES_ACTION;